import { FC } from "react";
import { Tag } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { BuyerBriefJob } from "../../../types/BuyerBriefTypes";
import { ListCard, ListCardField } from "../../../common/components/ListCard";
import { DateTime } from "../../../common/components/DateTime";

interface BuyerBriefJobCardProps {
    job: BuyerBriefJob;
}

export const BuyerBriefJobCard: FC<BuyerBriefJobCardProps> = ({ job }) => {
    const fields: ListCardField[] = [
        {
            label: "Supplier",
            span: 2,
            content: job.supplierName || `Brief #${job.briefId}`,
        },
        {
            label: "Status",
            content: (
                <Tag icon={<LoadingOutlined />} color="processing">
                    {job.status}
                </Tag>
            ),
        },
        {
            label: "Current Step",
            content: job.currentStep || "Initializing...",
        },
        {
            label: "Started",
            content: <DateTime date={new Date(job.startTime)} />,
        },
    ];

    return (
        <ListCard
            logoFallback={job.supplierName}
            fields={fields}
            style={{ background: "#fafafa", borderBottom: "1px solid #d9d9d9" }}
        />
    );
};
